import * as React from "react";
import { cn } from "@/lib/utils";

interface Thought {
  agent: string;
  thought: string;
}

interface TypingIndicatorProps {
  className?: string;
  currentThoughts?: Thought[];
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({ currentThoughts = [] }) => {
  return (
    <div className="w-full mb-5 pl-0">
      {/* Animation */}
      <div className={cn(
        "flex items-center gap-2 text-[13px] text-gray-500",
        currentThoughts.length > 0 ? "mb-2" : "mb-0"
      )}>
        <div className="flex gap-1 items-center">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="w-1 h-1 rounded-full bg-emerald-600 animate-pulse"
              style={{
                animationDelay: `${i * 0.2}s`
              }}
            />
          ))}
        </div>
      </div>

      {/* Current thoughts */}
      {currentThoughts.length > 0 && (
        <div className="pl-4 border-l-2 border-muted text-xs text-gray-500 leading-snug italic">
          {currentThoughts.slice(-2).map((thought, index) => (
            <div key={`${thought.agent}-${index}-${thought.thought.substring(0, 20)}`} className={cn(
                index < currentThoughts.slice(-2).length - 1 && "mb-1.5"
            )}>
              {thought.thought}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TypingIndicator;
